import React from 'react';
import { SeedAccountImages } from '../../../../../test-create-update/components/seed-esp-account/type';
import { Other } from '../../../../../../../../shared/svg/other';

// Helper function to get ESP icon
export const getEspIcon = (esp: string) => {
  if (!esp) return null;

  const iconPath = SeedAccountImages[esp.toLowerCase()];
  if (!iconPath) return <Other height={16} width={16} />;

  return (
    <img
      src={iconPath}
      width={16}
      height={16}
      alt={`${esp} icon`}
      className="esp-icon"
    />
  );
};
